import { RouterProvider } from 'react-router-dom';
import router from './Routes';
import { getCookie, removeCookie } from './utils/cookieFuns';
import Settings from "./Settings.json"
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { AppDispatch } from './redux/store';
import { setAlert } from './redux/slices/alertSlice';
import GlobalAlert from './Components/GlobalSnackbar';

function App() {
    const token = getCookie('session') ?? '';
    axios.defaults.baseURL = Settings[process.env.NODE_ENV].base_url;
    axios.defaults.headers.common.Authorization = `Bearer ${token}`;

    const dispatch = useDispatch<AppDispatch>();

    axios.interceptors.response.use(
        function (response) {
            if (
                response?.status === 200 &&
                response?.data?.responseMessage &&
                response?.data?.responseMessage?.trim() !== 'Success' &&
                response.config?.method !== 'get'
            ) {
                dispatch(
                    setAlert({
                        message:
                            response?.data?.responseMessage ||
                            response?.data?.result,
                        severity: 'success',
                    }),
                );
            }
            return response;
        },
        function (error) {
            if (error.response?.status === 401) {
                removeCookie('session');
                dispatch(
                    setAlert({
                        message: 'Session expired',
                        severity: 'error',
                    }),
                );
                window.location.href = '/';
            } else {
                dispatch(
                    setAlert({
                        message:
                            error?.response?.data?.responseMessage ||
                            error?.response?.data?.result ||
                            error?.response?.statusText ||
                            error?.message,
                        severity: 'error',
                    }),
                );
            }
            return error;
        },
    );


    return <>
        <RouterProvider router={router} />
        <GlobalAlert />
    </>;
}

export default App;
